<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
      row-id="brandCode"
      ><!--toolbar-->
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.brandStatus === 'Y' ? 'success' : 'danger'"
        >
          {{ row.brandStatusName }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'detail',
                  code: row.brandCode
                })
              "
            ></i>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'edit',
                  code: row.brandCode
                })
              "
              v-if="allow('M')"
            ></i>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.brandCode)"
              v-show="row.brandStatus === 'Y'"
              v-if="allow('D')"
            ></i>
          </el-tooltip>
        </div>
      </template>

      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  props: {
    tablePage: {
      default: null,
      type: Object
    },
    tableData: {
      default: () => []
    },
    loading: {
      default: false
    }
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => {
            this.$emit('submit')
          }
        },
        zoom: true,
        custom: true
      },
      tableColumn: [
        {
          field: 'seq',
          width: 50,
          fixed: 'left',
          align: 'center',
          type: 'seq'
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          fixed: 'right',
          width: 130,
          slots: {
            default: 'opt'
          }
        },
        {
          field: 'brandName',
          minWidth: 150,
          title: this.$l('table_label_brand_name') || '品牌名称',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          align: 'left'
        },
        {
          field: 'brandDesc',
          minWidth: 250,
          title: this.$l('table_label_brand_desc') || '品牌介绍',
          headerAlign: 'center',
          align: 'left'
        },
        {
          field: 'brandStatus',
          width: 80,
          title: this.$l('table_label_brand_status') || '状态',
          align: 'center',
          slots: { default: 'status' }
        },
        {
          field: 'createByName',
          width: 100,
          title: this.$l('table_label_create_by') || '创建人',
          align: 'center'
        },
        {
          field: 'createDate',
          width: 170,
          title: this.$l('table_label_create_date') || '创建时间',
          align: 'center'
        },
        {
          field: 'modifyByName',
          width: 100,
          title: this.$l('table_label_modify_by') || '修改人',
          align: 'center'
        },
        {
          field: 'modifyDate',
          width: 170,
          title: this.$l('table_label_modify_date') || '修改时间',
          align: 'center'
        }
      ]
    }
  },
  methods: {
    del(code) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning'
        }
      ).then(() => {
        this.$api.masterBrandDelApi({ brandCode: code }).then((res) => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || res.msg,
            type: 'success'
          })
          this.$emit('submit')
        })
      })
    }
  }
}
</script>
